import { SeItem } from '@poc-monorepo/shared';

export const routes: SeItem[] = [
  // {
  //   id: 'dashboard',
  //   code: '001',
  //   title: 'แดชบอร์ด',
  //   type: 'basic',
  //   icon: 'dashboard',
  //   link: '/app/fo',
  //   children: [],
  // },
  {
    id: 'admin-district',
    code: '000-admin-district',
    title: 'กำหนดสิทธิเขต',
    type: 'basic',
    icon: 'supervisor_account',
    link: '/app/admin-district',
    ischildActive: false,
    role: ['admin'],
  },
  {
    id: 'admin-branch',
    code: '000-admin-branch',
    title: 'กำหนดสิทธิสาขา',
    type: 'basic',
    icon: 'supervisor_account',
    link: '/app/admin-branch',
    ischildActive: false,
    role: ['district', 'admin'],
  },
  {
    id: 'branch-users',
    code: '000-branch-users',
    title: 'จัดการผู้ใช้สาขา',
    type: 'basic',
    icon: 'supervisor_account',
    link: '/app/branch-users',
    ischildActive: false,
    role: ['branch'],
  },
  {
    id: 'dashboard-overview',
    code: '000-dashboard-overview',
    title: 'ภาพรวมประจำเดือน',
    type: 'basic',
    icon: 'dashboard',
    link: '/app/dashboard-overview',
    ischildActive: false,
    role: ['branch', 'district', 'admin'],
    children: [],
  },
  {
    id: 'plan',
    code: '002',
    title: 'แผนงาน',
    type: 'collapsable',
    icon: 'work_history',
    role: ['branch', 'contract'],
    children: [
      {
        id: 'master-plan',
        code: '002-003',
        title: 'จัดการแผนหลัก',
        type: 'basic',
        // icon: 'work_history',
        link: '/app/master-plan',
        role: ['contract'],
        children: [],
      },
      {
        id: 'set-plan',
        code: '002-000',
        title: 'ร่างแผนจดมาตร',
        type: 'basic',
        // icon: 'work_history',
        link: '/app/set-plan',
        role: ['contract'],
        children: [],
      },
      {
        id: 'approve-plan',
        code: '002-001',
        title: 'สร้างเส้นทางอ่านมาตร',
        type: 'basic',
        // icon: 'work_history',
        link: '/app/approve-plan',
        role: ['branch'],
        children: [],
      },
      {
        id: 'manage-plan',
        code: '002-002',
        title: 'จัดการแผนงาน',
        type: 'basic',
        // icon: 'work_history',
        link: '/app/manage-plan',
        role: ['contract'],
        children: [],
      },
      {
        id: 'approve-manage-plan',
        code: '002-003',
        title: 'ขออนุมัติเปลี่ยนแปลงแผน',
        type: 'basic',
        // icon: 'work_history',
        link: '/app/approve-manage-plan',
        role: ['branch'],
        children: [],
      },
    ],
  },
  {
    id: 'following',
    code: '003',
    title: 'ติดตามผลการจดมาตร',
    type: 'collapsable',
    ischildActive: false,
    icon: 'gas_meter',
    role: ['branch', 'contract'],
    children: [
      {
        id: 'submit-invoice',
        code: '003-000-submit',
        title: 'การอ่านมาตรวัดน้ำ',
        type: 'basic',
        // icon: 'fiber_manual_record',
        link: '/app/submit-invoice',
        ischildActive: false,
        role: ['branch','contract'],
      },
      // {
      //   id: 'submit-invoice-response',
      //   code: '003-000-response',
      //   title: 'ผลการอ่านมาตรวัดน้ำ',
      //   type: 'basic',
      //   // icon: 'fiber_manual_record',
      //   link: '/app/submit-invoice-response',
      //   ischildActive: false,
      //   role: ['contract'],
      // },
      {
        id: 'invoice-report',
        code: '003-invoce-report',
        title: 'ใบแจ้งหนี้',
        type: 'basic',
        // icon: 'fiber_manual_record',
        link: '/app/invoice-report',
        ischildActive: false,
        role: ['contract'],
      },
      {
        id: 'report-overall',
        code: '003-001',
        title: 'ภาพรวมการจดมาตร',
        type: 'basic',
        // icon: 'fiber_manual_record',
        link: '/app/dashboard',
        ischildActive: false,
        role: ['contract'],
      },
      // {
      //   id: 'report-verification',
      //   code: '003-001',
      //   title: 'รายงานการตรวจสอบข้อมูล',
      //   type: 'basic',
      //   // icon: 'fiber_manual_record',
      //   link: '/app/report-verification',
      //   ischildActive: false,
      //   role: ['branch'],
      // },
      {
        id: 'report',
        code: '003-002',
        title: 'รายงาน',
        type: 'basic',
        // icon: 'fiber_manual_record',
        link: '/app/report',
        ischildActive: false,
        role: ['contract'],
      },
    ],
  },
  // {
  //   id: 'setting',
  //   code: '007',
  //   title: 'การตั้งค่า',
  //   type: 'collapsable',
  //   icon: 'settings',
  //   children: [
  //     {
  //       id: 'contract',
  //       code: '007',
  //       title: 'สัญญาผู้รับเหมา',
  //       type: 'basic',
  //       // icon: 'work_history',
  //       link: '/app/plan',
  //       children: [],
  //     },
  //   ],
  // },
  {
    id: 'settings',
    code: '005',
    title: 'ตั้งค่า',
    type: 'collapsable',
    ischildActive: false,
    icon: 'settings',
    role: ['branch'],
    children: [
      // {
      //   id: 'settings_wwcode&branch',
      //   code: '004-001',
      //   title: 'สร้างBA/หน่วยงาน',
      //   type: 'basic',
      //   // icon: 'fiber_manual_record',
      //   link: '/app/settings/wwcode',
      //   ischildActive: false,
      //   role: ['branch'],
      // },
      {
        id: 'setting-invoice',
        code: '004-002',
        title: 'กำหนดค่าใบแจ้งหนี้',
        type: 'basic',
        // icon: 'fiber_manual_record',
        link: '/app/setting-invoice',
        ischildActive: false,
        role: ['branch'],
      },
      {
        id: 'cis-log',
        code: '004-003',
        title: 'cis-log',
        type: 'basic',
        // icon: 'fiber_manual_record',
        link: '/app/cis-log',
        ischildActive: false,
        role: ['branch'],
      },
    ],
  },
  // {
  //   id: 'manage-user',
  //   code: '004',
  //   title: 'จัดการผู้ใช้งาน',
  //   type: 'collapsable',
  //   ischildActive: false,
  //   icon: 'person',
  //   role: ['branch'],
  //   children: [
  //     {
  //       id: 'create-user',
  //       code: '004-001',
  //       title: 'สร้างผู้ใช้งาน',
  //       type: 'basic',
  //       // icon: 'fiber_manual_record',
  //       link: '/app/create-user',
  //       ischildActive: false,
  //       role: ['branch'],
  //     },
  //   ],
  // },
];
